const documentationAutoMode = (actualURL) => {
  try {
    const [, , section, product, page] = actualURL.match(/\/developers\/(pt|es|en)\/(.*?)\/(.*?)\/(.*?)\//);
    return {
      section,
      product,
      page,
    };
  } catch {
    return {};
  }
};

const referenceAutoMode = (actualURL) => {
  if (!actualURL || typeof actualURL !== 'string') {
    return {
      section: 'unknown',
      product: 'not_apply',
    };
  }

  let section = 'reference';
  if (actualURL.match(/\/developers\/(pt|es|en)\/reference\/?$/)) {
    section = 'reference-home';
  }
  return {
    section,
    product: 'not_apply',
  };
};

const autoModeFunctions = {
  documentation: documentationAutoMode,
  reference: referenceAutoMode,
};

const getMelidataEventData = (actualURL, autoMode, lang, section, product) => {
  try {
    let finalSection = section;
    let finalProduct = product;

    if (autoMode) {
      const functionToCall = autoModeFunctions[autoMode];
      const values = functionToCall ? functionToCall(actualURL) : {};
      finalSection = values.section;
      finalProduct = values.product;
    }

    const eventData = {
      partial_path: actualURL?.replace(/\/developers\/(pt|es|en)/, ''),
      language_selected: lang?.toLowerCase(),
      section: finalSection,
      product: finalProduct,
    };
    return eventData;
  } catch (e) {
    console.log('Error in getMelidataEventData', e);
    return null;
  }
};

const shouldSendToMelidata = (lang) => {
  if (!['PT', 'ES', 'EN'].includes(lang?.toUpperCase())) {
    return false;
  }
  if (!window?.melidata) {
    return false;
  }
  return true;
};

const trackMelidataPageView = (melidataPath, lang, partialPath, autoMode) => {
  if (!shouldSendToMelidata(lang)) {
    return;
  }
  const destinyURL = `/developers/${lang}${partialPath}`;
  const eventData = getMelidataEventData(destinyURL?.replace(/\/$/, '').concat('/'), autoMode, lang);
  if (!eventData) {
    return;
  }
  window.melidata('send', 'view', {
    path: melidataPath,
    event_data: eventData,
  });
};

const trackMelidataEvent = (eventPath, eventData) => {
  if (!shouldSendToMelidata(eventData?.language_selected)) {
    return;
  }
  window.melidata('send', 'event', {
    path: eventPath,
    event_data: eventData,
  });
};


module.exports = { getMelidataEventData, trackMelidataPageView, trackMelidataEvent };
